import { PositioningMethod } from "building-types/annotation/annotationTypesEnum";
import type { DocEntityId } from "building-types/doc/docEntityId";
import { docEntityBaseNew } from "building-types/entities/docEntityBaseNew";
import type { ParameterRef, ParameterValueHandle } from "building-types/options/parameter";
import type { ContentTemplateInstance, DrawingTemplateInstance } from "building-types/views/planSets";
import { WRAPPER_CONTENT_TEMPLATE_INSTANCE_ID } from "building-types/views/planSets";
import type { Table } from "common/data/table";

/**
 * A wrapper content template instance is commonly used to present a content template that is not yet
 * instantiated in a plan set.
 */
export function contentTemplateInstanceNewWrapper(
  contentTemplateId: DocEntityId<"CONTENT_TEMPLATE">,
  templateType: "DRAWING" | "SHEET",
  parameterValues: Table<ParameterValueHandle | ParameterRef> = {},
): ContentTemplateInstance {
  if (templateType === "SHEET") {
    return {
      entityType: "CONTENT_TEMPLATE_INSTANCE",
      templateType: "SHEET",
      sheetNumber: "",
      sheetNumberPrefix: "",
      id: WRAPPER_CONTENT_TEMPLATE_INSTANCE_ID,
      sortIndex: 0,
      contentTemplateId,
      parameterValues,
      name: "WRAPPER_SHEET_TEMPLATE_INSTANCE",
      labels: {},
    };
  } else {
    return drawingTemplateInstanceNew({
      contentTemplateId,
      name: "WRAPPER_DRAWING_TEMPLATE_INSTANCE",
      id: WRAPPER_CONTENT_TEMPLATE_INSTANCE_ID,
      parameterValues,
    });
  }
}

export function contentTemplateInstanceIsWrapper(contentTemplateInstance: ContentTemplateInstance): boolean {
  return contentTemplateInstance.id === WRAPPER_CONTENT_TEMPLATE_INSTANCE_ID;
}

export type DrawingTemplateInstanceNewOptions = Pick<DrawingTemplateInstance, "contentTemplateId" | "parameterValues"> &
  Partial<Pick<DrawingTemplateInstance, "parentId" | "x" | "y" | "name" | "id">>;

export function drawingTemplateInstanceNew({
  contentTemplateId,
  parameterValues,
  parentId,
  x = 0,
  y = 0,
  name = "",
  id,
}: DrawingTemplateInstanceNewOptions): DrawingTemplateInstance {
  return {
    ...docEntityBaseNew("CONTENT_TEMPLATE_INSTANCE", id),
    templateType: "DRAWING",
    contentTemplateId,
    parameterValues,
    parentId,
    x,
    y,
    rotation: 0,
    positioningMethod: PositioningMethod.GLOBAL,
    name,
    labels: {},
  };
}
